exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n    display: inline-block;\n    white-space: nowrap;\n    cursor: pointer;\n\n    position: relative;\n}\n\n:host:focus {\n    outline: none;\n}\n\n.pcheckbox {\n    box-sizing: border-box;\n    height: 18px;\n    width: 18px;\n    border: solid 2px;\n    border-radius: 2px;\n    pointer-events: none;\n    transition: background-color 140ms, border-color 140ms;\n    display: inline-block;\n    position: relative;\n    vertical-align: middle;\n}\n\n.pcheckmark {\n    position: absolute;\n    width: 36%;\n    height: 70%;\n    transform-origin: 97% 86%;\n    -webkit-transform-origin: 97% 86%;\n    -webkit-transform: rotate(45deg);\n            transform: rotate(45deg);\n    border: none white;\n    border-right: calc(2 / 15 * 18px) solid;\n    border-bottom: calc(2 / 15 * 18px) solid;\n    margin-left: 1px;\n    margin-top: 1px;\n    color: white;\n}\n\n.plabel {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n    white-space: normal;\n    pointer-events: none;\n    padding-left: 8px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/polymer/paper-checkbox/paper-checkbox.component.css
// module id = ./src/app/components/polymer/paper-checkbox/paper-checkbox.component.css
// module chunks = main